import React from 'react'
import AnalyticsTable from './components/SpeechTable'

export default function WorkspaceAnalytics() {
    return <AnalyticsTable />
}
